// =====================================================
// AUTH TYPES
// =====================================================

export const LOAD_USER = 'LOAD_USER';
export const LOAD_USERS = 'LOAD_USERS';
export const DELETE_USER = 'DELETE_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILED = 'REGISTER_FAILED';
export const AUTH_CLEAN = 'AUTH_CLEAN';
export const LOGOUT = 'LOGOUT';
export const APPROVE_HIRE = 'APPROVE_HIRE';
export const REJECT_HIRE = 'REJECT_HIRE';
export const SEND_PROJECT = 'SEND_PROJECT';
export const ADD_HIRING = 'ADD_HIRING';
export const EDIT_PROFILE = 'EDIT_PROFILE';
export const CHANGE_PROFILE = 'CHANGE_PROFILE';
export const ADD_ART = 'ADD_ART';
export const APPROVEMENT = 'APPROVEMENT';
export const FOLLOW = 'FOLLOW';
export const UNFOLLOW = 'UNFOLLOW';

// =====================================================
// ALERT TYPES
// =====================================================

export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const SET_UPLOAD = 'SET_UPLOAD';

// =====================================================
// POST TYPES
// =====================================================

export const LOAD_POST = 'LOAD_POST';
export const LOAD_POSTS = 'LOAD_POSTS';
export const ADD_POST = 'ADD_POST';
export const LIKE_POST = 'LIKE_POST';
export const DISLIKE_POST = 'DISLIKE_POST';
export const COMMENT_POST = 'COMMENT_POST';
export const DELETE_COMMENT = 'DELETE_COMMENT';

// =====================================================
// PROFILE TYPES
// =====================================================

export const LOAD_PROFILE = 'LOAD_PROFILE';
